// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './DiamondImage.style';
const round_product = "/media/diamondshapes/diamondround/round-sample.jpg";
const oval_product = "/media/diamondshapes/diamondoval/oval-sample.jpg";
const princess_product = "/media/diamondshapes/diamondprincess/princess-sample.jpg";
const pear_product = "/media/diamondshapes/diamondpear/pear-sample.jpg";
const emerald_product = "/media/diamondshapes/diamondemerald/emerald-sample.jpg";
const cushion_product = "/media/diamondshapes/diamondcushion/cushion-sample.jpg";
const heart_product = "/media/diamondshapes/diamondheart/heart-sample.jpg";
const radiant_product = "/media/diamondshapes/diamondradiant/radiant-sample.jpg";
const marquise_product = "/media/diamondshapes/diamondmarquise/marquise-sample.jpg";
const asscher_product = "/media/diamondshapes/diamondasscher/asscher-sample.jpeg";

export class DiamondImage extends PureComponent {
    static propTypes = {
        diamond_shape: this.propTypes,
        image_url: this.propTypes,
        className: this.propTypes
    };

    state = {
        onLoadError: false
    };

    renderDiamondProductImage(image_url, diamond_shape) {
        const { onLoadError } = this.state;
        const { className } = this.props;

        switch (diamond_shape) {
            case "44":
            case "Round":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : round_product} loading="eager" className={className} />;
            case "45":
            case "Oval":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : oval_product} loading="eager" className={className} />;
            case "46":
            case "Princess":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : princess_product} loading="eager" className={className} />;
            case "47":
            case "Pear":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : pear_product} loading="eager" className={className} />;
            case "48":
            case "Emerald":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : emerald_product} loading="eager" className={className} />;
            case "49":
            case "Cushion":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : cushion_product} loading="eager" className={className} />;
            case "50":
            case "Heart":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : heart_product} loading="eager" className={className} />;
            case "51":
            case "Radiant":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : radiant_product} loading="eager" className={className} />;
            case "52":
            case "Marquise":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : marquise_product} loading="eager" className={className} />;
            case "53":
            case "Asscher":
                return <img onError={() => this.setState({ onLoadError: true })} src={image_url && !onLoadError ? image_url : asscher_product} loading="eager" className={className} />;
            default:
                return (
                    <></>
                );
        }
    }

    render() {
        const { diamond_shape, image_url } = this.props;

        return (
            <>
                {this.renderDiamondProductImage(image_url, diamond_shape)}
            </>
        );
    }
}

export default DiamondImage;
